// 共通関数
export default{
    methods: {
      existUser() {
        // ログインユーザーの存在確認
        if (!this.$store.state.user.id || this.$store.state.user.id == 0) {
          alert('ログイン情報がリセットされました。\n再度ログインしてください。');
          this.$router.push('/');
        }
      },
      logout() {
        this.$store.state.user = {};
        this.$router.push('/');
      },
      adjustUser(user) {
        return {
          id: user.id ? Number(user.id) : 0,
          userId: user.userId ? user.userId : '',
          name: user.name ? user.name : '',
          password: user.password ? user.password : '',
          subdomain: user.subdomain ? user.subdomain : '',
          roomcount: user.roomcount ? Number(user.roomcount) : 0,
          randomroomcount: user.randomroomcount ? Number(user.randomroomcount) : 0,
          role: user.role ? Number(user.role) : 0,
          parentId: user.parentId ? Number(user.parentId) : 0,
          stopF: user.stopF ? user.stopF : false,
          plan: user.plan ? user.plan : '',
          bg: user.bg ? user.bg : '',
          logo: user.logo ? user.logo : '',
          company: user.company ? user.company : '',
          clientId: user.clientId ? user.clientId : '',
          createdAt: user.createdAt ? user.createdAt : 0,
          roomTotal: user.roomTotal ? user.roomTotal : 0,
          randomroomRemain: user.randomroomRemain ? user.randomroomRemain : 0,
          randomroomPassword: user.randomroomPassword ? user.randomroomPassword : '' 
        }
      },
      adjustRoom(room) {
        return {
          id: room.id ? Number(room.id) : 0,
          name: room.name ? room.name : '',
          inCount: room.inCount ? Number(room.inCount) : 0,
          userId: room.userId ? room.userId : '',
          delban: room.delban ? room.delban : false,
          password: room.password ? room.password : '',
          remarks: room.remarks ? room.remarks : '',
          updated: room.created ? room.created : null,
          created: room.created ? room.created : null
        }
      }
    }
  }
